import React from 'react'
import ReactDOM from 'react-dom'
import getModule from './modules-map'

/**
 * Call with list of server side rendered components when the app is ready.
 * Each component should contain the follow values: "name", "props" and "id".
 *
 * @param components {Array} List of components to render.
 */
export default function delayedRender(components) {
  return components.map(({ name, props, id, error }) => {
    if (error) {
      const err = new Error(error)

      return Promise.reject(err)
    }
    const mod = getModule(name)
    if (mod) {
      /* Async import the required components when they are needed */
      return (
        mod
          .default()
          .then(module => render(module.default, props, id))
          // eslint-disable-next-line no-console
          .catch(err => console.error(err, { name, props, id, components }))
      )
    }

    return Promise.reject(`[delayedRender] Module not found: ${name}`)
  })
}

export function render(component, props, id) {
  const el = document.getElementById(id)

  if (component && el) {
    ReactDOM.render(React.createElement(component, props), el)
  } else if (!el) {
    throw new Error(`[delayedRender] Could not find element with id: '${id}'`)
  } else {
    throw new Error(
      `[delayedRender] Component not found for element with id: '${id}'`,
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/delayed-render.js